import { applyMiddleware, CombinedState, combineReducers, compose, createStore as _createStore } from 'redux';
import thunk from 'redux-thunk';

import * as reducers from '../../reducers';
import { IApplicationContext } from '../../types/applicationContext';
import { IApplicationState, TReduxActions, IReduxStore, TThunkDispatch } from '../../types/redux';

interface IThunkExt {
  dispatch: TThunkDispatch;
}

let storeReminder: IReduxStore;

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(
  context: IApplicationContext,
  initialState: Partial<IApplicationState>,
  debugEnabled: boolean,
) {
  const rootReducer = combineReducers<IApplicationState, TReduxActions>(reducers);

  const composeEnhancers = debugEnabled ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose : compose;

  const storeEnchancers = composeEnhancers(applyMiddleware(thunk.withExtraArgument(context)));

  const createStore = (): IReduxStore =>
    _createStore<CombinedState<IApplicationState>, TReduxActions, IThunkExt, {}>(
      rootReducer,
      initialState,
      storeEnchancers,
    );

  if (process.env.NODE_ENV === 'development' && debugEnabled) {
    if (!storeReminder) {
      storeReminder = createStore();
    }

    storeReminder.replaceReducer(rootReducer);

    return storeReminder;
  }

  return createStore();
}
